import React, { useContext,useState ,useEffect } from "react";
import { RxCross2 } from "react-icons/rx";
import { Link } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import AuthContext from "../context/AuthContext";
import FlagIcon from "../assets/imagesNew/india-icon.png";
import FlagIconBn from "../assets/imagesNew/bangladesh-flag-round-circle-icon.png";
import { toast } from "react-toastify";
import helpers from "../Utils/helpers";

const ReferBox = () => {
    let {setShowReferBox,lang, setEn, setBr,profileData} = useContext(AuthContext);
     function copy(text) {
            toast.success("Link Copied!");
            return window.navigator.clipboard.writeText(text);
          }

  const {t} = useTranslation()
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setShowReferBox(false);
      }}
    >
      
    
      <div className="login-notification">
       
      <div id="popInbox" className="pop-wrap">
        <a className="btn-close "   onClick={() => setShowReferBox(false)}></a>
        <div className="pop-title ">
          <h3 className=""> Refer </h3>
        </div>
        <div class="ebox text-center pb-0">
                <p> Your Referral Code </p>
                <h3>{profileData?.referalCode}</h3>
                <div class="referal-code">
                <img src="data:image/png;base64,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"/>
                </div>
                <div class="rc-btn">
                    <button class="rule-btn1 m-0 " onClick={() =>
                copy(
                  `https://${helpers?.getDomain()}/register?referral_code=${profileData?.referalCode}`
                )
              }> Copy Link </button>
                    <button class="rule-btn1 m-0" onClick={() =>
                  window.open(
                    `https://web.whatsapp.com/send?text=https://${helpers?.getDomain()}/register?referral_code=${profileData?.referalCode}`,
                    "_blank"
                  )
                }> Share </button>
                </div>
            </div>
        </div>
         
          
         </div>
     
    
      
    </OutsideClickHandler>
  );
};

export default ReferBox;
